import { Text } from "@mantine/core";
import { FC } from "react";
import { AcknowledgementLayout } from "@funded-here-interface/common";
import { useStyle } from "./PendingShareholderOnboard.styles";

const PendingShareholderOnboard: FC = () => {
  const { classes } = useStyle();

  return (
    <AcknowledgementLayout
      showLogo={false}
      content={
        <div className={classes.container}>
          <Text className={classes.headerText}>
            Pending Board Resolution Execution
          </Text>
          <Text className={classes.text}>
            Please note that your onboarding application has been approved. We
            are now waiting for all director(s) to execute the board resolution
            electronically to proceed with the next stage of onboarding.
          </Text>
        </div>
      }
    />
  );
};

export default PendingShareholderOnboard;
